import { useRef } from 'react';

import { Button } from '@components/button';
import { getPlaceholderHtml as getFilePlaceholderHtml } from '@components/field-mapping-file-field/extensions';
import { InstantUploadFileInput } from '@components/file-field/file-input';
import { IconUpload } from '@components/icons/upload';
import { InstantUploadFileFieldProps } from '@components/instant-upload-file-field';
import { useScopedTranslate } from '@locale/translate';
import { uuid } from '@utils/uuid';

import { EditorRefProp } from '../common';
import { ManuallyInputButtonProps, locale } from '../field-mapping-sidebar';

export const FileManualField = ({
  editorRef,
  onManualSelect,
}: EditorRefProp & Pick<ManuallyInputButtonProps, 'onManualSelect'>) => {
  const { t } = useScopedTranslate(locale);
  const fieldId = useRef(uuid()).current;
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <InstantUploadFileInput
        ref={fileInputRef}
        id={fieldId}
        onSelect={onManualSelect as InstantUploadFileFieldProps['onSelect']}
        onChange={(file) => {
          if (file) {
            editorRef.current?.insertContent(
              getFilePlaceholderHtml({ value: file.url, label: file.name }),
            );
          }
        }}
      />
      <Button
        variant="secondary"
        text={t('uploadFile')}
        iconLeft={<IconUpload />}
        onClick={() => fileInputRef.current?.click()}
      />
    </>
  );
};
